// Vendor libraries

import Vue from "vue";
import Buefy from "buefy";
import SmartTooltip from "@/shared/components/SmartTooltip.vue";
import VueMeta from "vue-meta";
import VueMq from "vue-mq";

// Local libraries

import router from "./router";
import { i18n } from "@/services/i18n";
import "@/services/helpers";

import Helpers from "@/plugins/helpers";
import Sentry from "@/plugins/sentry";
import Http from "@/plugins/http";
import Notificator from "@/plugins/notificator";
import Loading from "@/plugins/loading";
import Echo from "@/plugins/echo";
import routeReloader from "@/plugins/routeReloader";
import Form from "@/plugins/form";
import Public from "@/plugins/public";
import Dashboard from "@/plugins/dashboard";

/*
|--------------------------------------------------------------------------
| Styles
|--------------------------------------------------------------------------
*/

import _exports from "~/scss/_exports.scss?module";

Vue.config.productionTip = false;

/*
|--------------------------------------------------------------------------
| Vendor Plugins
|--------------------------------------------------------------------------
*/

if (process.env.MIX_PUSHER_APP_KEY) {
  Vue.use(Echo);
  Vue.use(routeReloader, { router: router });
}

Vue.use(VueMeta);
Vue.use(Buefy);
// Tooltips that stay on screen on mobile (same name, same API)
Vue.component("b-tooltip", SmartTooltip);
Vue.use(VueMq, {
  breakpoints: {
    mobile: parseInt(_exports.tablet.replace("px", "")),
    tablet: parseInt(_exports.desktop.replace("px", "")),
    desktop: parseInt(_exports.widescreen.replace("px", "")),
    widescreen: parseInt(_exports.fullhd.replace("px", "")),
    fullhd: Infinity
  }
});

/*
|--------------------------------------------------------------------------
| Local Plugins
|--------------------------------------------------------------------------
*/

// The order is important!
Vue.use(Sentry);
Vue.use(Notificator);
Vue.use(Http);
Vue.use(Helpers);
Vue.use(Loading);
Vue.use(Form);
Vue.use(Public);
Vue.use(Dashboard);

/*
 |--------------------------------------------------------------------------
 | Global Components
 |--------------------------------------------------------------------------
*/

Vue.component("v-layout", require("./layout.vue").default);

/*
|--------------------------------------------------------------------------
| Vue instance
|--------------------------------------------------------------------------
*/

const metadata = Vue.observable({ metadata: {} });

Object.defineProperty(Vue.prototype, "$metadata", {
  get() {
    return metadata.metadata;
  },

  set(value) {
    metadata.metadata = value;
  }
});

new Vue({
  el: "#app",
  router,
  i18n,
  metaInfo: {
    changed: info => {
      Vue.prototype.$metadata = _.cloneDeep(info);
    }
  }
});
